import React, { useEffect } from "react";
import clsx from "clsx";

import CssBaseline from "@material-ui/core/CssBaseline";
import Drawer from "@material-ui/core/Drawer";
import Box from "@material-ui/core/Box";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";

import Typography from "@material-ui/core/Typography";
import { connect } from "react-redux";
import IconButton from "@material-ui/core/IconButton";
import Badge from "@material-ui/core/Badge";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Link from "@material-ui/core/Link";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import NotificationsIcon from "@material-ui/icons/Notifications";
import CreateTask from "../CreateTask";
import Menu from "../Menu/index";
import NewTaskForm from "../NewTaskForm";
import NewProjectButton from "../NewProjectButton";
import { Redirect } from "react-router-dom";
import MeetingRoomIcon from "@material-ui/icons/MeetingRoom";
import { actionCreators } from "../Login/action";
import { actionCreators as projectActionCreators } from "../Project/action";
import Alert from "@material-ui/lab/Alert";
import { useParams } from "react-router-dom";
import Avatar from "@material-ui/core/Avatar";
import data from "../../../package.json";
import Checkbox from "@material-ui/core/Checkbox";
import SwitchColor from '../SwitchColor';
import SwitchKanban from '../SwitchKanban';
import { isLocalHost } from '../../helpers/isLocalHost';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import Copyright from '../../components/Copyright';
import { useStyles } from './style';
import { actionCreators as drawerActionCreators } from '../Drawer/action';


const PageWrapper = props => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);
  const [test, setTest] = React.useState(false);
 

  const handleDrawerOpen = () => {
    props.openDrawer();
  };

  const handleDrawerClose = () => {
    props.closeDrawer();
  };
  const fixedHeightPaper = clsx(classes.paper);

  const fixedHeightPaperMore = clsx(classes.paper, classes.fixedHeightMore);

  const [width, setWidth] = React.useState(window.innerWidth);

  const handleWindowSizeChange = () => {
    setWidth({ width: window.innerWidth });
  };

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
  });

  useEffect(() => {
    if (window.innerWidth <= 1000) {
       handleDrawerClose();
    }
    window.removeEventListener("resize", handleWindowSizeChange);
    
    document.oncontextmenu = (e) => {
      
      if (!isLocalHost && e.button === 2) {
          e.preventDefault();
          return false;
      }
    }

    window.addEventListener("online", handleNetworkChange);
    window.addEventListener("offline", handleNetworkChange);

  }, []);

  const isStandalone = window.matchMedia("(display-mode: standalone)").matches;

  const isMobile = isStandalone || width <= 1328 || width.width <= 1328;


  const [openNetworkConnectionAlert, setNetworkConnectionAlert] = React.useState(false);

  const handleClick = () => {
    setNetworkConnectionAlert(true);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setNetworkConnectionAlert(false);
  };

  function handleNetworkChange(event) {
    if (navigator.onLine) {
      setNetworkConnectionAlert(false);
    } else {
      setNetworkConnectionAlert(true);
    }
  }
  
  return test ? <Redirect to="/test" />: !props.uid ? (
    <Redirect to="/" />
  ) : ( 
    <>
     

      <div className={classes.root}>
        <CssBaseline />
        <AppBar
          position="absolute"
          className={clsx(classes.appBar, props.isOpenDrawer && classes.appBarShift)}
        >
          <Toolbar className={classes.toolbar}>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              className={clsx(
                classes.menuButton,
                props.isOpenDrawer && classes.menuButtonHidden
              )}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              component="h1"
              variant="h6"
              color="inherit"
              noWrap
              className={classes.title}
            >
              {props.projectName !== undefined ? (
                <>
                  <Checkbox
                    checked={props.isProjectDone}
                    style={{color: "white"
                  
                  }}
                    onChange={
                      props.isProjectDone
                        ? () => props.projectOpen(props.projectId)
                        : () => props.projectDone(props.projectId)
                    }
                    value="primary"
                    inputProps={{ "aria-label": "primary checkbox" }}
                  />
                  {props.projectName}
                </>
              ) : (
                props.title
              )}
              {!isMobile && <CreateTask />}
              {/* <NewProjectButton /> */}
            </Typography>
            <SwitchColor />
            <SwitchKanban />
            {isLocalHost &&
            <IconButton
              color="inherit"
              style={{ fontSize: "14px" }}
              onClick={() => setTest(true)}
            >
              Test
              <MeetingRoomIcon />
            </IconButton>
             }
            <IconButton
              color="inherit"
              style={{ fontSize: "14px" }}
              onClick={() => props.logOut()}
            >
              <MeetingRoomIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Drawer
          variant={isMobile ? false : "permanent"}
          classes={{
            paper: clsx(classes.drawerPaper, !props.isOpenDrawer && classes.drawerPaperClose)
          }}
          open={props.isOpenDrawer}
          onClose={handleDrawerClose}
        >
          <div className={classes.toolbarIcon}>
            <IconButton onClick={handleDrawerClose}>
              {props.userName ? (
                <>
                  {props.userPhotoURL && (
                    <Avatar alt="Remy Sharp" src={props.userPhotoURL} />
                  )}
                  <span className={classes.userName}>
                    {props.userName}
                    <br />
                    {props.counterDone &&  `${props.counterDone} done`}
                  </span>
                </>
              ) : (
                "zenGTD"
              )}{" "}
              <ChevronLeftIcon />
            </IconButton>
          </div>
          <Menu />
        </Drawer>
        <main className={classes.content}>
          <div className={classes.appBarSpacer} />





          {/* <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}> */}
        {openNetworkConnectionAlert && <Alert onClose={handleClose} severity="warning">
          No Internet access. Turn on your internet connection. 
        </Alert>}


      {/* </Snackbar> */}
          <Container
            maxWidth="lg"
            className={classes.container}
            variant="filled"
          >
            
               <NewTaskForm fixedHeightPaperMore={fixedHeightPaperMore} isVisible={!isMobile && props.isFormIsOpen}/>

               <NewTaskForm 
               {...props.initialForm} 
               fixedHeightPaperMore={fixedHeightPaperMore}
               isVisible={props.isEditFormIsOpen} />
               
               {props.children}
        

            <Box pt={4}>
              <Copyright />
            </Box>
          </Container>
         
        </main>
        
      </div>
      
      {isMobile && <CreateTask isFab={true} />}
     

    </>
  );
};

const mapStateToProps = (state, props) => {
  return {
    isFormIsOpen: state.isFormIsOpen.isFormIsOpen,
    isEditFormIsOpen: state.isFormIsOpen.isEditFormIsOpen,
    initialForm: state.isFormIsOpen.initialForm,
    uid: state.user && state.user.user.uid,
    isProjectDone:
      state.tasks &&
      props.projectId &&
      state.tasks[props.projectId] &&
      state.tasks[props.projectId].done,
    projectName:
      state.tasks &&
      props.projectId &&
      state.tasks[props.projectId] &&
      state.tasks[props.projectId].title,
    userName: state.user && state.user.user.displayName,
    userPhotoURL: state.user && state.user.user.photoURL,
    counterDone:
      state.tasks &&
      Object.keys(state.tasks).filter(task => state.tasks[task].done).length,
     isOpenDrawer: state.isOpenDrawer
  };
};

export default connect(mapStateToProps, {
  ...actionCreators,
  ...projectActionCreators, 
  ...drawerActionCreators
})(PageWrapper);
